import {ECurrency} from '@edna/utils';

import {TLeadClient} from 'src/containers/LeadCompanyClients';

import {EResellerIds} from '../User';

export type TCompanyDetails = {
  country: string;
  legalAddress: string;
  postAddress?: string;
  taxNumber: string;
  ogrn?: string;
  kpp?: string;
  companyName?: string;
  siteAddress?: string;
  entityType?: string;
};

export enum EDetailsAction {
  FILL = 'FILL',
  ADD = 'ADD',
  UPDATE = 'UPDATE',
}

export enum EResidentCountry {
  RUS = 'RUS',
  BLR = 'BLR',
  KAZ = 'KAZ',
  FOREIGN = 'FOREIGN',
}

export enum EEntityType {
  LEGAL = 'LEGAL',
  INDIVIDUAL = 'INDIVIDUAL',
}

export const DEFAULT_COMPANY_DETAILS: TCompanyDetails = {
  country: '',
  legalAddress: '',
  taxNumber: '',
};

export const DEFAULT_TENANT_LEAD_DETAILS: Partial<TLeadClient> = {
  id: -1,
  resellerId: -1 as EResellerIds,
  companyName: '',
  currencyCode: ECurrency.RUB,
  countryCode: '',
  documentType: '' as TLeadClient['documentType'],
  taxNumber: '',
  contactName: '',
  email: '',
  phone: '',
  responsibleManagerId: -1,
  maxOverdraft: 0,
  securityDeposit: 0,
  activateLicenseDebt: false,
  licensePaymentTerm: 0,
  termBeforeTerminationLicense: 0,
  ogrn: '',
  paymentType: '' as TLeadClient['paymentType'],
  billingDisabled: true,
};

export const LEGAL_ENTITY_TAX_NUMBER_LENGTH = 10;
export const INDIVIDUAL_TAX_NUMBER_LENGTH = 12;
